<template>
    <v-col v-if="anyKeywords" class="py-3 px-2" style="background-color: rgb(255, 246, 189);">
        <h4 class="px-4">{{ $t('servicesystem.common_objects.email_settings.keywords') }}</h4>
        <p class="px-4 my-1" v-html="$t('servicesystem.common_objects.email_settings.keywords_hint')" />
        <QTextField v-model="searchword" label="Search" dense singleline externaledit clearable class="px-4 my-2">
            <template v-slot:prepend>
                <v-icon>mdi-magnify</v-icon>
            </template>
        </QTextField>
        <v-list class="py-0" style="background-color: transparent;">
            <v-list-item v-for="key in searchedKeywords" :key="key" dense style="min-height: 28px;" @click="copy(key)">
                <v-list-item-icon class="ma-0 mr-2" style="min-width: unset;">
                    <v-icon size="14">mdi-content-copy</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="py-0">
                    <v-list-item-title>{{ key }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-col>
</template>


<script>
export default {
    name: 'EmailKeywordsNote',
    props: {
        replaceKeyWords: Array,
    },
    components: {},

    data() {
        return {
            isLoading: false,
            editObject: null,
            searchword: '',
        }
    },

    mounted() { },

    methods: {
        async copy(mytext) {
            try {
                await navigator.clipboard.writeText(mytext);
            } catch ($e) {
                alert('unable to copy text');
            }
        },
    },

    computed: {
        anyKeywords() {
            return this.replaceKeyWords && this.replaceKeyWords[0];
        },

        searchedKeywords() {
            var query = this.searchword ?? '';
            return this.replaceKeyWords?.filter(keyword => keyword.toLowerCase().includes(query.toLowerCase()));
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>